module.exports = __webpack_public_path__ + "media/invite/sort-up-123e8149.svg";